// @tcc
import { inferUnit } from 'util/unitConversion';

// constants
import { applicationTypes, scriptTypes } from 'constants/scripts';
import {
  applicationProductFormats,
  fertilityProductFormats
} from 'constants/products';
import { UNIT_TYPES } from 'constants/unitTypes';

export const getLocaleUnitSymbol = (unitType) => {
  return inferUnit(unitType).symbol.universal;
};

export const getProductRateUnitTypeByFormat = (format) => {
  if (format === fertilityProductFormats.WET) {
    return 'volumetric-density';
  }
  if (format === applicationProductFormats.WET) {
    return 'volumetric-density';
  }
  return 'area-density.application.dry-fertilizer';
};

export const getProductRateUnitTypeByUnit = (unit) => {
  switch (unit) {
    case UNIT_TYPES.gal_ac:
    case UNIT_TYPES.l_ha:
    case UNIT_TYPES.l_ac:
      return 'volumetric-density';
    default:
      return 'area-density.application.dry-fertilizer';
  }
};

export const getProductRateUnitSymbol = (applicationType, productFormat) => {
  switch (applicationType) {
    case applicationTypes.SEED:
      return getLocaleUnitSymbol('seed-density');
    case applicationTypes.FERTILIZER:
    case applicationTypes.APPLICATION:
      return getLocaleUnitSymbol(getProductRateUnitTypeByFormat(productFormat));
    default:
      return '';
  }
};

export const getProductRateUnitTypeByScriptType = ({scriptType, format}) => {
  if(scriptType === scriptTypes.PLANTING) {
    return 'seed-density';
  }
  return getProductRateUnitTypeByFormat(format);
};

/**
 * Formats a numeric value as a percentage string with optional plus/minus sign and decimal handling.
 *
 * @param {number} percentage - The numeric value to format.
 * @param {Object} [options={}] - Formatting options.
 * @param {boolean} [options.isPlusMinus=false] - Whether to prefix positive values with a `+`.
 *   - If `true`, positive numbers get a `+` sign.
 *   - Negative numbers always get a `-` sign.
 *   - If `false`, positive numbers have no prefix.
 * @param {boolean} [options.isDecimal=false] - Whether the input is a decimal (e.g., `0.123` → `"12.3%"`).
 *
 * @returns {string|null} The formatted percentage string (e.g., `"+12.3%"`, `"-5.0%"`, `"45.6%"`),
 * or `null` if the input is not a number.
 *
 * @example
 * getPercentage(12.3, { isPlusMinus: true }); // "+12.3%"
 * getPercentage(-5, { isPlusMinus: true });  // "-5.0%"
 * getPercentage(0.456, { isDecimal: true }); // "45.6%"
 * getPercentage(45.6);                       // "45.6%"
 */
export const getPercentage = (percentage, { isPlusMinus = false, isDecimal = false } = {}) => {
  if (typeof percentage !== 'number') {
    return null;
  }

  const value = isDecimal ? percentage * 100 : percentage;

  const isNegative = value < 0;
  const formatted = parseFloat(Math.abs(value)).toFixed(1);
  const plusMinus = isNegative ? '-' : isPlusMinus ? '+' : '';

  return `${plusMinus}${formatted}%`;
};

